<template>
	<el-container>
		<el-header>
			<menus></menus>
		</el-header>
		<el-main>
			<router-view />
		</el-main>
		<el-footer>
			<footers></footers>
		</el-footer>
		<div class="concantShow hidden-xs-only">
			<p class="concantTitle">联系我们</p>
			<ul class="concantList">
				<li><a class="ceshi" href="tencent://message/?Site=baidu.com&uin=986215530&Menu=yes">售前咨询</a></li>
				<li ><a class="ceshi" href="tencent://message/?Site=baidu.com&uin=986215530&Menu=yes">售后咨询</a></li>
				<li @click="$router.push({path:'/contact'})" class="about_us">联系我们</li>
			</ul>
			<p class="concantPhone">
				<p class="phoneTexts"><i class="iconfont el-iconstel-line "></i>联系电话</p>
				<p class="phones"><!-- <a href="0371-86623267"> -->0371-86623267<!-- </a> --></p>
			</p>
			
		</div>
		<div class="concantShow hidden-sm-and-up">
			<ul>
				<li><a href="tel:0371-86623267"><img src="../assets/images/home/dianhua.png" alt=""></a></li>
				<li @click="$router.push({path:'/contact'})"><img src="../assets/images/home/liuyan.png" alt=""></li>
				<li @click="$router.push({path:'/contact'})"><img src="../assets/images/home/kf.png" alt=""></li>
			</ul>
		</div>
	</el-container>

</template>

<script>
	import menus from './home/menu.vue'
	import footers from './home/footer.vue'
	import request from '../assets/js/request.js'
	import qs from 'qs'
	export default {
		components: {
			menus,
			footers
		},
		name: 'home',
		data() {
			return {
				beian:'',
				product:[{
					id:1,
					name:'高压清洗机'
				},{
					id:3,
					name:'管道疏通机'
				},{
					id:12,
					name:'除锈清洗机'
				},{
					id:15,
					name:'墙面拉毛机'
				},{
					id:14,
					name:'高压冲毛机'
				},{
					id:2,
					name:'全自动清洗机'
				}]
			}
		},
		created() {
			this.getData()
		},
		methods:{
			getData(){
				request.post(this.settings.apiBaseUrl + '/api/index/about', qs.stringify({}), {
					headers: {}
				}).then((res) => {
					if (res.code == 1) {
				this.beian = res.data.beian
				} else {
					this.$message.error(res.msg)
				}
				})
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	a{
		color: #000;
	}
	.el-footer {
		background-color: #153B67;
		color: #FFFFFF;
		height: 285px !important;
		text-align: center;
		font-size: 14px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #FFFFFF;
		padding: 0px!important;
	}

	.el-aside {
		background-color: #D3DCE6;
		color: #333;
		text-align: center;
		line-height: 200px;
	}

	.el-main {
		height: auto;
		padding: 0;
		clear: both;
	}

	.el-header {
		width: 100%;
		height: 208px !important;
		padding: 0;
	}

	.concantShow {
		position: fixed;
		top: 67%;
		right: 0;
		width: 10%;
		height: 230px;
		z-index: 9999;
		background: #FFFFFF;
		box-shadow: 0px 2px 12px 1px rgba(0, 0, 0, 0.1);
	}
	.about_us{
		font-weight: bold;
		font-size: 20px;
	}
	.concantTitle{
		width: 100%;
		height: 65px;
		background-color: #216BD1;
		text-align: center;
		line-height: 65px;
		font-size: 20px;
		font-family: Microsoft YaHei;
		/* font-weight: 400; */
		color: #FFFFFF;
		font-weight: 600;
	}
	.concantList{
		/* padding-top: 10px; */
	}
	.concantList li {
		width: 60%;
		height: 35px;
		margin: 0px auto;
		text-align: center;
		border-bottom: 1px solid #EAEAEA;
		line-height: 35px;
		cursor: pointer;
	}
	.concantPhone{
		width: 100%;
		text-align: center;
	}
	.phoneTexts{
		margin: 5px 0;
		
	}
	 .phoneTexts,.phones ,.phones a{
		text-align: center;
		width: 100%;
		height: 20px;
		line-height: 18px;
		font-size: 20px;
		font-family: Microsoft YaHei;
		font-weight: 600;
		color: #343434;
	}
	.footer{
		width: 100%;
		height: 230px;
		padding: 30px 220px;
	}
	.footer ul{
		width: 25%;
		height: auto;
		float: left;
	}
	.footer ul .productC{
		width: 49%;
		text-align: left;
	}
	.footer ul .productR{
		width: 50%;
		text-align: left;
		box-sizing: border-box;
	}
	.footer ul:nth-child(1) span{
		text-align: left;
	}
	.footer ul span{
		display: block;
		font-size: 20px;
		line-height: 40px;
	
	}
	.footer ul  li{
		font-size: 16px;
		line-height: 40px;
		cursor: pointer;
	}
	.beian{
		border-top: 1px solid rgba(0,0,0,0.2);
		display: block;
		width: 100%;
		height: 45px;
		line-height: 45px;
	}
	@media screen and (max-width: 750px) {
		.concantShow {
				position: fixed;
				top: 70%;
				right: 0;
				width: 40%;
				height: 150px;
				z-index: 9999;
				background-image: url(../assets/images/home/concat.png);
				background-size: 100% 100%;
			}
			.concantShow ul li{
				float: left;
				width: 33%;
				text-align: center;
				height: 100px;
				line-height:150px ;
				vertical-align: middle;
			}
			.concantShow ul li img{
				width: 100px;
				height:100px;
				vertical-align: middle;
				text-align: center;
			}
	}
</style>



// WEBPACK FOOTER //
// src/components/home.vue